export const siteData = JSON.parse("{\"base\":\"/\",\"lang\":\"en-US\",\"title\":\"Unique docs\",\"description\":\"Unique network documentation portal\",\"head\":[[\"link\",{\"rel\":\"icon\",\"href\":\"/favicon.svg\"}]],\"locales\":{}}")
